import { render, staticRenderFns } from "./lk-search.vue?vue&type=template&id=1ca3faa1&"
import script from "./lk-search.vue?vue&type=script&lang=js&"
export * from "./lk-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/lk/lk-search/lk-search.vue
// module id = 187
// module chunks = 0